import Vue from 'vue'
import VueGallery from 'vue-gallery'

Vue.component('VueGallery', VueGallery)